import * as tslib_1 from "tslib";
import { HttpClient } from '@angular/common/http';
import { Constants } from '../config/constants.config';
import { Nutrients, Token, UserProfileViewModel, UserWeightHistory } from '../viewModels/userProfile.viewModel';
import { map } from 'rxjs/operators';
import { MealViewModel } from '../viewModels/meal.viewModel';
import { DiaryChatMessages } from '../viewModels/diary.viewModel';
var MealWithDailyMealViewModel = /** @class */ (function (_super) {
    tslib_1.__extends(MealWithDailyMealViewModel, _super);
    function MealWithDailyMealViewModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return MealWithDailyMealViewModel;
}(MealViewModel));
export { MealWithDailyMealViewModel };
var MealOverwriteViewModel = /** @class */ (function () {
    function MealOverwriteViewModel() {
    }
    return MealOverwriteViewModel;
}());
export { MealOverwriteViewModel };
var MasterNote = /** @class */ (function () {
    function MasterNote() {
    }
    return MasterNote;
}());
export { MasterNote };
var MasterService = /** @class */ (function () {
    function MasterService(httpClient, constants) {
        this.httpClient = httpClient;
        this.constants = constants;
    }
    MasterService.prototype.getProfiles = function (skip, per_page, search) {
        var strs = "skip=" + skip + "&per_page=" + per_page;
        if (search != null && search.length >= 1) {
            strs += "&search=" + search;
        }
        return this.httpClient.get(this.constants.apiURL() + "/master/profiles/?" + strs);
    };
    MasterService.prototype.getProfilesCount = function () {
        return this.httpClient.get(this.constants.apiURL() + "/master/profiles/count/");
    };
    MasterService.prototype.getUserProfile = function (id) {
        return this.httpClient.post(this.constants.apiURL() + "/master/profiles/single/", {
            id: id
        });
    };
    MasterService.prototype.updateUserProfile = function (userProfile) {
        return this.httpClient.put(this.constants.apiURL() + "/master/profiles/single/", userProfile)
            .pipe(
        // tslint:disable-next-line:no-shadowed-variable
        map(function (userProfile) {
            return userProfile;
        }));
    };
    MasterService.prototype.createProfile = function (first_name, last_name, email, password) {
        return this.httpClient.post(this.constants.apiURL() + "/master/profiles/", {
            email: email,
            password: password,
            first_name: first_name,
            last_name: last_name
        });
    };
    MasterService.prototype.addSubAccount = function (email) {
        return this.httpClient.post(this.constants.apiURL() + "/master/profile/add-subaccount/", {
            email: email
        });
    };
    MasterService.prototype.sendLoginInfo = function (email, password, text, files) {
        var formData = new FormData();
        for (var x = 0; x < files.length; x++) {
            formData.append('file_' + files[x].name, files[x], files[x].name);
        }
        formData.append('email', email + '');
        formData.append('password', password + '');
        formData.append('text', text + '');
        return this.httpClient.post(this.constants.apiURL() + "/master/profile/send/login/info/", formData);
    };
    MasterService.prototype.masterLogin = function (user_id) {
        return this.httpClient.post(this.constants.apiURL() + "/master/login/as/", {
            'user_id': user_id
        });
    };
    MasterService.prototype.getMealOverwrites = function (user_id) {
        return this.httpClient.post(this.constants.apiURL() + "/master/meals/overwrites/", {
            id: user_id
        });
    };
    MasterService.prototype.getMealsWithDailyMeals = function (user_id) {
        return this.httpClient.post(this.constants.apiURL() + "/master/meals/daily/meals/", {
            id: user_id
        });
    };
    MasterService.prototype.updateMealsWithDailyMeals = function (user_id, overwrites) {
        return this.httpClient.put(this.constants.apiURL() + "/master/meals/overwrites/", {
            id: user_id,
            overwrites: overwrites
        });
    };
    MasterService.prototype.checkIsSubAccountUnderMaster = function () {
        return this.httpClient.post(this.constants.apiURL() + "/master/profile/check/sub/profile/", {});
    };
    MasterService.prototype.getSubscriptions = function (id) {
        return this.httpClient.post(this.constants.apiURL() + "/master/subscriptions/", {
            id: id
        });
    };
    MasterService.prototype.getSingleSubscription = function (id, subscriptionId) {
        return this.httpClient.post(this.constants.apiURL() + "/master/subscriptions/single/", {
            id: id,
            subscription_id: subscriptionId
        });
    };
    MasterService.prototype.deleteSubscription = function (id, subscriptionId) {
        return this.httpClient.post(this.constants.apiURL() + "/master/subscriptions/delete/", {
            id: id,
            subscription_id: subscriptionId
        });
    };
    MasterService.prototype.createSubscription = function (id, status, from_date, to_date) {
        return this.httpClient.post(this.constants.apiURL() + "/master/subscriptions/create/", {
            id: id,
            status: status,
            from_date: from_date,
            to_date: to_date
        });
    };
    MasterService.prototype.updateSubscription = function (id, subscription_id, status, from_date, to_date) {
        return this.httpClient.put(this.constants.apiURL() + "/master/subscriptions/", {
            id: id,
            subscription_id: subscription_id,
            status: status,
            from_date: from_date,
            to_date: to_date
        });
    };
    MasterService.prototype.getNotes = function (id) {
        return this.httpClient.post(this.constants.apiURL() + "/master/notes/", {
            id: id
        });
    };
    MasterService.prototype.deleteNote = function (id, noteId) {
        return this.httpClient.post(this.constants.apiURL() + "/master/notes/delete/", {
            id: id,
            note_id: noteId
        });
    };
    MasterService.prototype.getSingleNote = function (id, noteId) {
        return this.httpClient.post(this.constants.apiURL() + "/master/notes/single/", {
            id: id,
            note_id: noteId
        });
    };
    MasterService.prototype.createNote = function (id, title, text) {
        return this.httpClient.post(this.constants.apiURL() + "/master/notes/create/", {
            id: id,
            title: title,
            text: text,
        });
    };
    MasterService.prototype.updateNote = function (id, note_id, title, text) {
        return this.httpClient.put(this.constants.apiURL() + "/master/notes/", {
            id: id,
            note_id: note_id,
            title: title,
            text: text
        });
    };
    MasterService.prototype.getOverwrites = function (user_id) {
        return this.httpClient.post(this.constants.apiURL() + "/master/user/overwrites/macros/", {
            user_id: user_id,
        });
    };
    MasterService.prototype.updateOverwrites = function (user_id, overwrites, daileMealPercentageOverwrites) {
        var newOverwrites = [];
        overwrites.forEach(function (overwrite) {
            var mealPercentageOverwrites = [];
            if (daileMealPercentageOverwrites[overwrite.id] !== undefined) {
                daileMealPercentageOverwrites[overwrite.id].forEach(function (percentageOverwrite) {
                    mealPercentageOverwrites.push({
                        meal_id: percentageOverwrite.meal.id,
                        overwrite_percentage: percentageOverwrite.overwrite_percentage
                    });
                });
            }
            newOverwrites.push({
                day: overwrite.day,
                daily_meal_id: overwrite.daily_meal_id,
                overwrite_all_calories: overwrite.overwrite_all_calories,
                overwrite_protein: overwrite.overwrite_protein,
                overwrite_carbs: overwrite.overwrite_carbs,
                overwrite_fat: overwrite.overwrite_fat,
                daily_meal_macro_overwrites: mealPercentageOverwrites
            });
        });
        return this.httpClient.put(this.constants.apiURL() + "/master/user/overwrites/macros/", {
            user_id: user_id,
            overwrites: newOverwrites
        });
    };
    MasterService.prototype.uploadInBodyXlsxFile = function (user_id, fileToUpload) {
        var formData = new FormData();
        formData.append('file', fileToUpload, fileToUpload.name);
        formData.append('user_id', user_id + '');
        return this.httpClient.post(this.constants.apiURL() + "/master/inbody/xlsx/", formData);
    };
    MasterService.prototype.changeMasterReadyProfile = function (user_id) {
        return this.httpClient.post(this.constants.apiURL() + "/master/profile/change/master/ready/", {
            'user_id': user_id
        });
    };
    MasterService.prototype.getMasterNotReadyProfile = function () {
        return this.httpClient.get(this.constants.apiURL() + "/master/profile/change/master/ready/");
    };
    MasterService.prototype.getUnSeenMessages = function () {
        return this.httpClient.get(this.constants.apiURL() + "/diary/chat/master/not/seen/");
    };
    MasterService.prototype.getWeightHistory = function (user_id) {
        return this.httpClient.post(this.constants.apiURL() + "/master/profile/weight/history/", {
            'user_id': user_id
        });
    };
    MasterService.prototype.getInBodyHistory = function (user_id) {
        return this.httpClient.get(this.constants.dataURL() + "/v1/inbody/" + user_id);
    };
    MasterService.prototype.getNutrients = function (user_id, date_from, date_to) {
        return this.httpClient.post(this.constants.apiURL() + "/master/profile/nutrients/", {
            'user_id': user_id,
            'date_from': date_from,
            'date_to': date_to,
        });
    };
    MasterService.prototype.getDiarySummary = function (masterUserId, dateFrom, dateTo, userClientIds) {
        return this.httpClient.post(this.constants.dataURL() + "/v2/diary/master/summary", {
            'masterUserId': masterUserId,
            'fromDate': dateFrom,
            'toDate': dateTo,
            'userClientIds': userClientIds
        });
    };
    MasterService.prototype.getDiarySummaryClients = function (masterUserId, dateFrom, dateTo) {
        return this.httpClient.post(this.constants.dataURL() + "/v2/diary/master/summary/clients", {
            'masterUserId': masterUserId,
            'fromDate': dateFrom,
            'toDate': dateTo
        });
    };
    MasterService.prototype.updateDiarySummaryClients = function (masterUserId, dateFrom, dateTo, userClientIds) {
        return this.httpClient.put(this.constants.dataURL() + "/v2/diary/master/summary/clients", {
            'masterUserId': masterUserId,
            'fromDate': dateFrom,
            'toDate': dateTo,
            'userClientIds': userClientIds
        });
    };
    MasterService.prototype.getMasterAutoDiaryGenerationConfigs = function () {
        return this.httpClient.get(this.constants.apiURL() + "/master/auto-diary-generation/config/");
    };
    MasterService.prototype.getMasterAutoDiaryGenerationConfig = function (id) {
        return this.httpClient.get(this.constants.apiURL() + "/master/auto-diary-generation/config/" + id);
    };
    MasterService.prototype.deleteMasterAutoDiaryConfig = function (id) {
        return this.httpClient.delete(this.constants.apiURL() + "/master/auto-diary-generation/config/delete/" + id);
    };
    MasterService.prototype.getMasterAutoDiaryRecipes = function (masterUserId) {
        return this.httpClient.get(this.constants.dataURL() + "/v1/master/recipes/" + masterUserId);
    };
    MasterService.prototype.createMasterAutoDiaryRecipes = function (dto) {
        return this.httpClient.post(this.constants.apiURL() + "/master/auto-diary-generation/config/", dto);
    };
    MasterService.prototype.updateMasterAutoDiaryRecipes = function (dto) {
        return this.httpClient.put(this.constants.apiURL() + "/master/auto-diary-generation/config/", dto);
    };
    return MasterService;
}());
export { MasterService };
